import {useRef} from "react";

import {Loader} from "@pg-design/loader-module";

import {Checkbox, ICheckboxProps} from "./Checkbox";

import {checkboxStyle, checkboxWrapStyle, loader} from "./CheckboxButton.module.css";

type IButtonCheckboxProps = ICheckboxProps & {
    isLoading?: boolean;
};

export function CheckboxButton(props: IButtonCheckboxProps) {
    const {isLoading, id = props.name, checkedMarkColor = "var(--globals-checkbox-checkedColor)", ...restProps} = props;
    const checkboxRef = useRef<HTMLInputElement | null>(null);

    const isPropsCheckedStyle = {border: "1px solid var(--colors-gray-500)"};

    return (
        <div
            className={checkboxWrapStyle}
            style={!!props.checked ? isPropsCheckedStyle : {}}
            onClick={(e) => {
                if (!props.readOnly && (e.target as HTMLElement).nodeName !== "INPUT" && (e.target as HTMLElement).nodeName !== "LABEL") {
                    props.onChange(props.name, !props.checked, props.value as HTMLInputElement["value"]);
                }
            }}
        >
            <Checkbox ref={checkboxRef} className={checkboxStyle} id={id} checkedMarkColor={checkedMarkColor} {...restProps} />
            {isLoading && (
                <div className={loader}>
                    <Loader size="sm" />
                </div>
            )}
        </div>
    );
}
import {useRef} from "react";

import {Loader} from "@pg-design/loader-module";

import {Checkbox, ICheckboxProps} from "./Checkbox";

import {checkboxStyle, checkboxWrapStyle, loader} from "./CheckboxButton.module.css";

type IButtonCheckboxProps = ICheckboxProps & {
    isLoading?: boolean;
};

export function CheckboxButton(props: IButtonCheckboxProps) {
    const {isLoading, id = props.name, checkedMarkColor = "var(--globals-checkbox-checkedColor)", ...restProps} = props;
    const checkboxRef = useRef<HTMLInputElement | null>(null);

    const isPropsCheckedStyle = {border: "1px solid var(--colors-gray-500)"};

    return (
        <div
            className={checkboxWrapStyle}
            style={!!props.checked ? isPropsCheckedStyle : {}}
            onClick={(e) => {
                if (!props.readOnly && (e.target as HTMLElement).nodeName !== "INPUT" && (e.target as HTMLElement).nodeName !== "LABEL") {
                    props.onChange(props.name, !props.checked, props.value as HTMLInputElement["value"]);
                }
            }}
        >
            <Checkbox ref={checkboxRef} className={checkboxStyle} id={id} checkedMarkColor={checkedMarkColor} {...restProps} />
            {isLoading && (
                <div className={loader}>
                    <Loader size="sm" />
                </div>
            )}
        </div>
    );
}
